export const getBear = (bear, props) => ({
  ...props.drawer.items.find((item) => item.type === bear.type),
  name: bear.name,
});
